import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Megaphone } from "lucide-react";

// Small "Sponsored" sidebar slot rendered on the registry / home page.
// Pulls campaigns where status=active AND paid_through > now.
export default function SponsorSidebar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/campaigns/active", { params: { limit: 4 } });
        if (alive) setItems(data.items || []);
      } catch {
        /* ignore — sidebar is non-critical */
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <aside
      className="border border-zinc-300 bg-white p-4"
      data-testid="sponsor-sidebar"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="label-eyebrow flex items-center gap-1.5">
          <Megaphone size={11} /> Sponsored
        </div>
        <a
          href="/advertise"
          className="text-[10px] uppercase tracking-widest font-bold text-zinc-500 hover:text-red-600"
          data-testid="sidebar-advertise-link"
        >
          Advertise →
        </a>
      </div>

      {items.length === 0 ? (
        <a
          href="/advertise"
          className="block border border-dashed border-zinc-300 p-4 text-center text-xs font-mono text-zinc-500 hover:border-red-600 hover:text-red-600 transition-colors"
          data-testid="sidebar-empty-cta"
        >
          Your ad here<br />
          <span className="text-zinc-400">$100 donation · 30-day sponsor slot · No subscription</span>
        </a>
      ) : (
        <div className="space-y-3">
          {items.map((c) => (
            <a
              key={c.id}
              href={c.ad_link_url}
              target="_blank"
              rel="noreferrer sponsored nofollow"
              className="block border border-zinc-200 hover:border-zinc-900 transition-colors group"
              data-testid={`sponsor-card-${c.id}`}
            >
              <div className="aspect-[4/3] bg-zinc-100 overflow-hidden">
                <img
                  src={c.ad_image_url}
                  alt={c.ad_title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <div className="p-3">
                <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                  {c.advertiser_name}
                </div>
                <div className="font-display font-bold text-sm leading-snug mt-1 line-clamp-2">
                  {c.ad_title}
                </div>
              </div>
            </a>
          ))}
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-zinc-200 text-[10px] font-mono text-zinc-400 leading-relaxed">
        Sponsored placements are paid and clearly labeled. Paws on Record does not
        endorse advertisers. <a href="/legal" className="underline hover:text-zinc-700">Policy</a>.
      </div>
    </aside>
  );
}
